// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

// eslint-disable-next-line no-unused-vars
import { PlanStatusType } from "@/enums/planStatus";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Plan Get
/**
 *
 * @param {{params: object, query: { date: string, planStatus: PlanStatusType, employeeId: string, customerId: string, search: string, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Plan.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Plan Create
/**
 *
 * @param {{"customerId": "string","employeeId": "string","planDate": string, note?: string }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Plan.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Plan.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan Update
/**
 *
 * @param {{ planDate: string, order?: number, isActive: boolean, planStatus?: string, customerId?: string, employeeId?: string }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Plan.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Plan.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan Route
/**
 *
 * @param {{params: object, query: {employeeId: string, planDate: string}}} option
 *
 * @returns
 */
export const Route = async (option) => {
  const response = await $api.get(Endpoints.Plan.Route(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan PlansByCustomer
/**
 *
 * @param {{params: object, query: {customerId: string, timeType: "Future" | "Past", planStatus: PlanStatusType, page: number, limit: number }}} option
 *
 * @returns
 */
export const PlansByCustomer = async (option) => {
  const response = await $api.get(Endpoints.Plan.PlansByCustomer(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan PlansByEmployee
/**
 *
 * @param {{params: object, query: {timeType: "Future" | "Past", planStatus: PlanStatusType, page: number, limit: number }}} option
 *
 * @returns
 */
export const PlansByEmployee = async (option) => {
  const response = await $api.get(Endpoints.Plan.PlansByEmployee(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan GetMonthlyPlansByEmployee
/**
 *
 * @param {{params: object, query: {employeeId: string, month: number, year: number }}} option
 *
 * @returns
 */
export const GetMonthlyPlansByEmployee = async (option) => {
  const response = await $api.get(
    Endpoints.Plan.GetMonthlyPlansByEmployee(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan GetMonthlyPlansByEmployee
/**
 *
 * @param {{params: object, query: {employeeId: string }}} option
 *
 * @returns
 */
export const GetLastPlanWithEmployee = async (option) => {
  const response = await $api.get(
    Endpoints.Plan.GetLastPlanWithEmployee(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Plan GetMonthlyPlansByEmployee
/**
 *
 * @param {{params: object, query: {startDate: string, endDate: string }}} option
 *
 * @returns
 */
export const GetAllWithPlanDate = async (option) => {
  const response = await $api.get(Endpoints.Plan.GetAllWithPlanDate(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan ChangeOrders
/**
 *
 * @param {Array<{ planId: string, newOrder: number }>} items
 *
 * @returns
 */
export const ChangeOrders = async (items) => {
  const response = await $api.post(Endpoints.Plan.ChangeOrders(), items);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Plan ByLocation
/**
 * @param {{ params?: object, query?: { locationId?: string, geoJsonId?: string, startDate?: string, endDate?: string, page?: number, limit?: number } }} option
 * @returns
 */
export const ByLocation = async (option = {}) => {
  const response = await $api.get(Endpoints.Plan.ByLocation(option));
  const checker = await ResponseChecker(defaultMessages, response);

  if (checker.message === "OK") {
    return checker;
  }

  if (response?.isSuccess && response?.data) {
    return {
      ...response,
      message: "OK",
    };
  }

  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Route,
  PlansByCustomer,
  PlansByEmployee,
  GetMonthlyPlansByEmployee,
  GetLastPlanWithEmployee,
  GetAllWithPlanDate,
  ChangeOrders,
  ByLocation,
};
